import { useEffect, useState } from "react";
import { formatCurrency } from "../util";

const useProposalApplication = ({ project }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (project.id) {
      setData([
        {
          heading: project.name,
          content: [],
        },
        {
          content: [
            `
                <q>Community: ${project.community}</q>
                <q>Address 1: ${project.community_address1}</q>
                <q>Address 2: ${project.community_address2}</q>
                <q>Project Location: ${project.project_location}</q>
                <q>Country: ${project.country}</q>
                <q>Province: ${project.province}</q>
                <q>Community Contact Name: ${project.creator?.first_name} ${
              project.creator.other_names + " " || ""
            }${project.creator?.last_name}</q>
                  <q>Community Contact Email: ${project.creator.email}</q>
                  <q>Community Contact Phone: ${
                    project.creator.phone || "NA"
                  }</q>
    
                  <q>PDO Contact Name: ${project.partners[0]?.first_name}  ${
              project.partners[0]?.other_names
                ? project.partners[0]?.other_names + " "
                : ""
            }${project.partners[0]?.last_name}</q>
                  <q>PDO Contact Email: ${project.partners[0].email}</q>
                  <q>PDO Contact Phone: ${project.partners[0].phone || "NA"}</q>
                  <q>Planned Start Date: ${
                    new Date(project.planned_start_date).toDateString() || "NA"
                  }</q>
                  <q>Planned End Date: ${
                    new Date(project.planned_end_date).toDateString() || "NA"
                  }</q>
                  <q>Currency: ${project.currency?.name}</q>
                `,
          ],
        },
        {
          heading: "Background",
          content: [project.description],
        },
        {
          heading: "Goal",
          content: [project.aim],
        },
        {
          heading: "Purpose",
          content: [project.purpose],
        },

        {
          heading: "Objectives",
          content: [[...project.objectives.map((i) => i.name)]],
        },
        {
          heading: "Planned Measures Activities",
          content: [
            {
              type: "orderedList",
              items: [...project.activities.map((i) => i.name)],
            },
          ],
        },
        {
          heading: "Results",
          content: [
            {
              type: "orderedList",
              items: [...project.expected_results.map((i) => i.name)],
            },
          ],
        },
        {
          heading: "Selected Indicators",
          content: [project.selected_indicators],
        },
        {
          heading: "Sustainability Plan",
          content: [project.sustainability_plan],
        },
        {
          heading: "Justification",
          content: [project.justification],
        },
        {
          heading: "Monitoring and Supervision",
          content: [project.monitoring_supervision],
        },
        {
          heading:
            "How This Project Helps Address The Issues Of The GC26 & DC27",
          content: [project.issues],
        },
        {
          heading: "Budget",
          content: [
            {
              type: "table",
              rows: [
                [
                  "No.",
                  "Description",
                  "Category",
                  "Quantity",
                  "Amount",
                  "Total",
                ],

                ...project.budget.map((i, index) => {
                  return [
                    ++index,
                    i.name,
                    i.sub_category,
                    i.quantity,
                    i.amount,
                    formatCurrency(i.quantity * i.amount),
                  ];
                }),
                ,
                [
                  "Total",
                  "",
                  "",
                  "",
                  "",
                  formatCurrency(
                    project.budget.reduce(
                      (acc, item) => item.amount * item.quantity + acc,
                      0
                    )
                  ),
                ],
              ],
            },
          ],
        },
        {
          heading: "Budget by Category",
          content: [
            {
              type: "table",
              rows: [
                ["No.", "Description", "Amount"],

                ...project.catBudget.map((i, index) => {
                  return [++index, i.name, formatCurrency(i.amount)];
                }),
                ,
                [
                  "Total",
                  "",
                  formatCurrency(
                    project.catBudget.reduce(
                      (acc, item) => Number(item.amount) + acc,
                      0
                    )
                  ),
                ],
              ],
            },
          ],
        },
        //End of Budget
      ]);
    }
  }, [project]);

  return data;
};

export default useProposalApplication;
